import '@/bootstrapWayfinder';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { createApp, createSSRApp, h } from 'vue';
import { initializeTheme } from '@/composables/useAppearance';
import AppLayout from '@/layouts/AppLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import SettingsLayout from '@/layouts/settings/Layout.vue';
import { initializeFlashToast } from '@/lib/flashToast';
import { setUrlDefaults } from '@/wayfinder';

const appName =
    (typeof window !== 'undefined' && window.__SITE_DISPLAY_NAME__) ||
    import.meta.env.VITE_APP_NAME ||
    'Laravel';

function syncWayfinderLocale(locale: unknown): void {
    if (locale === 'en' || locale === 'sr') {
        setUrlDefaults({ locale });
    }
}

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    layout: (name) => {
        switch (true) {
            case name === 'Welcome':
                return null;
            case name.startsWith('auth/'):
                return AuthLayout;
            case name.startsWith('settings/'):
                return [AppLayout, SettingsLayout];
            default:
                return AppLayout;
        }
    },
    progress: {
        color: '#4B5563',
    },
    setup({ el, App, props, plugin }) {
        syncWayfinderLocale(props.initialPage.props.locale);

        router.on('success', (event) => {
            syncWayfinderLocale(event.detail.page.props.locale);
        });

        const factory = import.meta.env.SSR ? createSSRApp : createApp;
        const app = factory({ render: () => h(App, props) });
        app.use(plugin);

        if (import.meta.env.SSR) {
            return app;
        }

        app.mount(el);
    },
});

if (!import.meta.env.SSR) {
    initializeTheme();
    initializeFlashToast();
}
